import React from 'react';

function SimpleCard(props) {
    const { className, title, children, style } = props;

    return (
        <div className={`dashboardView-card ${className || ''}`} style={style}>
            <p className="dashboardView-card-title">{title}</p>
            <div className="dashboardView-card-content">
                {children}
            </div>
        </div>
    );
}

export default SimpleCard;